/* eslint-disable import/prefer-default-export */
import { useState, useCallback } from "react";

export const useModalHelpers = () => {
  const [openModal, setOpenModal] = useState(null);
  const [modalProps, setModalProps] = useState(null);

  const isOpen = useCallback(type => openModal === type, [openModal]);
  const getProps = useCallback(() => modalProps, [modalProps]);

  const setModal = (type, props) => {
    setOpenModal(type);
    setModalProps(props);
  };

  const clearModal = () => {
    setOpenModal(null);
    setModalProps(null);
  };

  return { isOpen, setModal, clearModal, getProps };
};
